import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { getServiceNameWithNickname } from "../../../utils/getServiceNameWithNickname";
import Notification from "../../elements/notification/Notification";
import GoToBackButton from "../../elements/goToBack/GoToBack";
import { useHistory } from "react-router-dom";
import * as moment from "moment";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import PageSpinner from "../../elements/spinner/PageSpinner";
import { TextField } from "@material-ui/core";
import ProcessingBalanceRefilingForm from "./ProcessingBalanceRefilingForm";
import ClipboardInput from "../../elements/copyToClipboard/ClipboardInput";
import { AppContext } from "../../../App";

import { StyledBlockLabel, StyledFormBlock, StyledFormGrid, StyledInputBlock } from "../../styles/styledTabsForm";
import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledPaymentDetailsWrapper } from "../styledPayment";
import RenderStatus from "../../styles/styledStatus";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { useTranslation } from "react-i18next";

const PaymentDetailsContainer = ({ match }) => {
  const { t } = useTranslation("transactionDetailsPage");
  const history = useHistory();
  let [payment, setPayment] = useState();

  const { user } = useContext(AppContext);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });


  // TODO add pusher
  const updateTransaction = (message) => {
    payment = JSON.parse(message.data);
    setPayment(payment);
  }

  const fetchPayment = () => {
    axios.get("/api/payments/" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setPayment(response.data);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    fetchPayment();
  }, []);

  if (!payment) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("meta.paymentTitle")}</title>
        </Helmet>
        <StyledPaymentDetailsWrapper>
          <div className="refiling-details-head">
            <GoToBackButton
              pb="10"
              handler={() => {history.goBack();}}
            />
            <div className="refiling-details-head__status">
              <RenderStatus status={payment.status.value} />
            </div>
          </div>
          <StyledFormGrid>
            <StyledFormBlock>
              <StyledBlockLabel>
                {t("refilingRequest")}
              </StyledBlockLabel>
              <StyledInputBlock>
                <ClipboardInput
                  label="Id"
                  value={payment.id}
                  readonly={true}
                />
                <ClipboardInput
                  label="Reference id"
                  value={payment.referenceId}
                  readonly={true}
                />
                <TextField
                  className="grid-form__input"
                  label={t("project")}
                  type="text"
                  value={payment.connection.project.name}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("service")}
                  type="text"
                  value={getServiceNameWithNickname(payment.connection.service.name, payment.connection.service.nickname)}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("paymentSystem")}
                  type="text"
                  value={payment.paymentSystem.name}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("currency")}
                  type="text"
                  value={payment.currency.asset}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("amount")}
                  type="text"
                  value={payment.amount}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("processedAmount.payment")}
                  type="text"
                  value={payment.processedAmount}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("createdAt")}
                  type="text"
                  value={moment((payment.createdAt * 1000)).format("DD-MM-YYYY, H:mm:ss")}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("updatedAt")}
                  type="text"
                  value={moment((payment.updatedAt * 1000)).format("DD-MM-YYYY, H:mm:ss")}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("paymentType")}
                  type="text"
                  value={payment.paymentType}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("transactionType")}
                  type="text"
                  value={payment.transactionType}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                {payment.relatedReferenceId &&
                  <TextField
                    className="grid-form__input"
                    label="Related reference id"
                    type="text"
                    value={payment.relatedReferenceId}
                    variant="filled"
                    InputProps={{
                      readOnly: true
                    }}
                  />
                }
                {payment.note &&
                  <TextField
                    className="grid-form__input"
                    label={t("note")}
                    type="text"
                    value={payment.note}
                    variant="filled"
                    InputProps={{
                      readOnly: true
                    }}
                  />
                }
              </StyledInputBlock>
              <div className="clear-column" />
            </StyledFormBlock>
            {payment.status.value === "NEW" &&
              <ProcessingBalanceRefilingForm
                payment={payment}
                notification={notification}
                setNotification={setNotification}
                type="payments"
                fetchAction={fetchPayment}
              />}
          </StyledFormGrid>
        </StyledPaymentDetailsWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default PaymentDetailsContainer;